import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaugeChartComponent } from './gauge-chart.component';
import { ChartModule } from 'angular-highcharts';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [GaugeChartComponent],
  imports: [CommonModule, ChartModule,MaterialModule],
  exports: [GaugeChartComponent],
})
export class GaugeChartModule {}
